module.exports = __webpack_public_path__ + "img/banner-badge.25f13226.png";